var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5834 15.2933V17.4978C37.5834 19.4558 36.8659 21.1053 35.5846 22.2462C34.3204 23.4024 32.4925 24.0499 30.3229 24.0499V26.8403C30.3229 27.8887 29.0246 28.5208 28.0679 27.9349L26.4109 26.9483C26.5646 26.4703 26.6329 25.9462 26.6329 25.3912V19.1166C26.6329 15.9716 24.3096 13.8749 20.8246 13.8749H9.22502C8.98585 13.8749 8.76377 13.8903 8.54169 13.9058V9.63534C8.54169 5.70409 11.4459 3.08325 15.8021 3.08325H30.3229C34.6792 3.08325 37.5834 5.70409 37.5834 9.63534",
    stroke: "white",
    strokeWidth: 2.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41669 19.1167C3.41669 16.1875 5.43252 14.1679 8.54169 13.9058C8.76377 13.8904 8.98585 13.875 9.22502 13.875H20.8246C24.3096 13.875 26.6329 15.9717 26.6329 19.1167V25.3912C26.6329 25.9462 26.5646 26.4704 26.4109 26.9483C25.7788 29.2146 23.6946 30.6329 20.8246 30.6329H16.1779L11.0188 33.7317C10.8458 33.8385 10.6437 33.9005 10.4345 33.9109C10.2252 33.9214 10.0168 33.8798 9.83183 33.7908C9.6469 33.7018 9.49255 33.5687 9.38556 33.4061C9.27858 33.2435 9.22305 33.0575 9.22502 32.8683V30.6329C7.48252 30.6329 6.03044 30.1088 5.02252 29.1992C3.99752 28.2742 3.41669 26.9637 3.41669 25.3912",
    stroke: "white",
    strokeWidth: 2.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.99b977f225b659ae0b284699b8534fde.svg";
export { ForwardRef as ReactComponent };